import { useState } from 'react';
import { faqs } from '../../data/parasHomeData';

export default function FAQSection() {
  const [faqOpen, setFaqOpen] = useState(null);

  return (
    <section className="section faq-section" id="faq" aria-label="Frequently Asked Questions">
      <div className="section-inner">
        <div className="faq-layout">
          <div>
            <span className="section-label">FAQ</span>
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-desc" style={{ marginTop: '1rem' }}>
              Have more questions? Reach us at{' '}
              <a href="mailto:goparas@gmail.com" style={{ color: 'var(--green)' }}>goparas@gmail.com</a>{' '}
              or call{' '}
              <a href="tel:+917405001130" style={{ color: 'var(--green)' }}>+91 74050 01130</a>
            </p>
          </div>
          <div className="faq-list" itemScope itemType="https://schema.org/FAQPage">
            {faqs.map((faq, i) => (
              <div key={i} className="faq-item" itemScope itemType="https://schema.org/Question">
                <button
                  className={`faq-q${faqOpen === i ? ' open' : ''}`}
                  onClick={() => setFaqOpen(faqOpen === i ? null : i)}
                  aria-expanded={faqOpen === i}
                  itemProp="name"
                >
                  {faq.q}
                  <span className="faq-chevron" aria-hidden="true">v</span>
                </button>
                <div
                  className={`faq-a${faqOpen === i ? ' open' : ''}`}
                  itemScope
                  itemType="https://schema.org/Answer"
                  itemProp="acceptedAnswer"
                  aria-hidden={faqOpen !== i}
                >
                  <span itemProp="text">{faq.a}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
